const STORAGE_KEY = 'himothy.rest-timer.v1'

export type RestTimerState = {
  endsAt: number
  durationSeconds: number
}

export function startRestTimer(durationSeconds: number, now = Date.now()): RestTimerState {
  const state = { endsAt: now + durationSeconds * 1000, durationSeconds }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  return state
}

export function readRestTimer(now = Date.now()): RestTimerState | null {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (!raw) return null

  try {
    const state = JSON.parse(raw) as RestTimerState
    if (!Number.isFinite(state.endsAt) || state.endsAt <= now) {
      localStorage.removeItem(STORAGE_KEY)
      return null
    }
    return state
  } catch {
    localStorage.removeItem(STORAGE_KEY)
    return null
  }
}

export function remainingRestSeconds(state: RestTimerState, now = Date.now()) {
  return Math.max(0, Math.ceil((state.endsAt - now) / 1000))
}

export function clearRestTimer() {
  localStorage.removeItem(STORAGE_KEY)
}

// The timer is deadline based rather than interval-count based. After a
// locked/suspended screen resumes, remaining time is recalculated from endsAt.
